import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from 'context/auth'

function RequireRole({ roles, redirectTo = '/', children }) {
  const { currentUser } = useAuth()
  if (!roles.includes(currentUser?.role)) return <Navigate to={redirectTo} replace />
  return children
}

export default RequireRole
